export default __webpack_public_path__ + "static/media/NewSmallCrossIcon.0f63877a.svg";